const expiryDateWave2Active = window.start.settings.enable_expiry_date_wave_2
  || (window.start.siteDataV2?.clientExperiments?.show_card_expiry_text_input_field_02 === 'v2|show_card_expiry_text_input_field')
  || (window.start.siteDataV2?.clientExperiments?.enable_combined_ux_experiments_wave_01 === 'v1|enable_combined_ux_experiments');

const validExpiryDateErrorKey = expiryDateWave2Active
  ? 'errors.formFields.cardexpiry.wave2'
  : 'errors.formFields.cardexpiry';

const validExpiryDate = () => (expiryDate) => {
  if (typeof expiryDate === 'undefined') {
    if (expiryDateWave2Active && expiryDate === undefined) {
      return 'errors.formFields.required';
    }
    return validExpiryDateErrorKey;
  }
  
  const date = new Date(window.siteObj.date);
  const actualMonth = date.getMonth() + 1;
  const actualYear = date.getFullYear();
  let selectedYear;
  let selectedMonth;
  let isValidInputLength;
  
  if (typeof expiryDate === 'string') {
    if (expiryDate === '') {
      return validExpiryDateErrorKey; // todo: Improve messaging - specifically say 'Please type the expiry date'
    }
    if (isNaN(expiryDate.split('/')[0]) || isNaN(expiryDate.split('/')[1])) {
      return validExpiryDateErrorKey;
    }
    selectedYear = parseInt(`20${expiryDate.split('/')[1]}`);
    selectedMonth = parseInt(expiryDate.split('/')[0]);
    isValidInputLength = expiryDate.split('/')[0].length === 2 && selectedYear.toString().length === 4;
  } else {
    selectedYear = parseInt(expiryDate.expirationYear);
    selectedMonth = parseInt(expiryDate.expirationMonth);
    isValidInputLength = true;
    if (isNaN(selectedMonth)) {
      return validExpiryDateErrorKey; // todo: Improve messaging - specifically say 'Please select a month'
    }
    if (isNaN(selectedYear)) {
      return validExpiryDateErrorKey; // todo: Improve messaging - specifically say 'Please select a year'
    }
  }
  
  const isValid = selectedMonth <= 12 && selectedMonth > 0 && (selectedYear > actualYear || (selectedYear === actualYear && selectedMonth >= actualMonth));
  
  if (!isValid || !isValidInputLength) {
    return validExpiryDateErrorKey;
  }
};

export default validExpiryDate;
